import React from 'react';
import toLower from 'lodash/fp/toLower';
export var SortArrowUp = function SortArrowUp() {
  return /*#__PURE__*/React.createElement("span", {
    className: 'sort-icon sort-asc'
  });
};
export var SortArrowDown = function SortArrowDown() {
  return /*#__PURE__*/React.createElement("span", {
    className: 'sort-icon sort-desc'
  });
};
export var SortArrows = function SortArrows(_ref) {
  var direction = _ref.direction;
  return /*#__PURE__*/React.createElement("span", {
    className: "sort-arrows sort-".concat(toLower(direction))
  });
};